<template>
    <div>
  
  
      <div
        class="text-nowrap box-status d-flex justify-content-center aling-items-center  px-4 font-logo pt-2px"
        :class="displayClass(status)"
        style=""
        :style="{ fontSize:'12px' }"
      >
        {{ displayText(status) || '-' }}
      </div>
  
    </div>
  </template>
  
  <script>
  import fn from "@/helpers/utility";
  export default {
    name: "App",
  
    props: {
      status: {
        type: String,
        default: ""
      },
      message: {
        type: String,
        default: ""
      }
    },
    data() {
      return {};
    },
    methods: {},
    computed: {
      displayText(){
        return value=>{  
          if (value == "approved") {
            return fn.orderCredit.thai['approved'];
          } else if (value == "pending") {
            return fn.orderCredit.thai['pending'];
          } else if (value == "cancelled") {
            return fn.orderCredit.thai['cancelled'];
          }    
        }
      },
  
      displayClass(){
        return value=>{  
          if (value == "approved") {
            return 'tab-success';
          } else if (value == "pending") {
            return 'tab-delivery';
          } else if (value == "cancelled") {
            return 'tab-cancel';
          }      
        }
      },
    },
    watch: {},
    components: {},
  
  };
  </script>
  
  <style>
  .tab-success {
    color: #34c38f;
    background: rgba(52, 195, 143, 0.25);
  }
  .tab-delivery {
    background: rgba(241, 180, 76, 0.25);
    color: #f1b44c;
  }
  .tab-cancel {
    background: #808080;
    color: #cccccc;
  }

  .pt-2px{
    padding-top:2px;
  }

  </style>
  
  